import { SovosBox, SovosTypography } from "mosaic-react";
import React from "react";

const EntityAiSuggestions = ({ entities, fileType, onSelect, suggestions, warnings }) => (
    <>
        {suggestions.length > 0 && (
            <SovosBox
                sx={{
                    mt: 1,
                    border: "1px solid",
                    borderColor: "primary.light",
                    borderRadius: 1,
                    overflow: "hidden",
                }}
            >
                {suggestions.map((suggestion, index) => {
                    const match = entities.find(
                        (entity) => entity.cdm_entity_name === suggestion.entity_name,
                    );
                    const resolvedFileType = match?.file_type;
                    const selected = resolvedFileType && fileType === resolvedFileType;
                    return (
                        <SovosBox
                            aria-disabled={!resolvedFileType}
                            component="button"
                            disabled={!resolvedFileType}
                            key={suggestion.entity_name}
                            onClick={() => onSelect(resolvedFileType, suggestion.score)}
                            sx={{
                                alignItems: "center",
                                bgcolor: selected ? "primary.50" : "transparent",
                                border: "none",
                                borderBottom: index < suggestions.length - 1 ? "1px solid" : "none",
                                borderColor: "divider",
                                cursor: resolvedFileType ? "pointer" : "default",
                                display: "flex",
                                fontFamily: "inherit",
                                gap: 1,
                                px: 1.5,
                                py: 0.875,
                                textAlign: "left",
                                width: "100%",
                            }}
                        >
                            <SovosBox sx={{ flex: 1, minWidth: 0 }}>
                                <SovosTypography variant="caption" fontWeight={600}>
                                    {match?.entity_name || suggestion.entity_name}
                                </SovosTypography>
                                {suggestion.rationale && (
                                    <SovosTypography
                                        color="text.secondary"
                                        sx={{
                                            display: "-webkit-box",
                                            fontSize: 11,
                                            overflow: "hidden",
                                        }}
                                        title={suggestion.rationale}
                                        variant="caption"
                                    >
                                        {suggestion.rationale}
                                    </SovosTypography>
                                )}
                            </SovosBox>
                            <SovosTypography variant="caption" color="success.dark">
                                {Math.round(suggestion.score * 100)}%
                            </SovosTypography>
                        </SovosBox>
                    );
                })}
            </SovosBox>
        )}
        {warnings.length > 0 && (
            <SovosBox sx={{ mt: 0.75, p: 1, borderRadius: 1, bgcolor: "warning.light" }}>
                {warnings.map((warning) => (
                    <SovosTypography key={warning} variant="caption" color="warning.dark">
                        {warning}
                    </SovosTypography>
                ))}
            </SovosBox>
        )}
    </>
);

export default EntityAiSuggestions;
